// extracted by mini-css-extract-plugin
export default {"container":"style_container__BFMtJ","containerWithFile":"style_containerWithFile__sIPV6"};